import React from 'react';
import { useNavigate } from 'react-router-dom';

function WelcomePage() {
  const navigate = useNavigate();

  return (
    <section className="welcome-section">
      <div className="content-wrapper">
        <div className="icon-wrapper">
          <span className="material-symbols-outlined">neurology</span>
        </div>

        <h1 className="title">Welcome to Health Spark AI</h1>
        <p className="subtitle">Unlock your wellness potential with personalized AI insights.</p>
      </div>

      <div className="button-wrapper">
        <button 
          className="btn-primary"
          onClick={() => navigate('/language')}
        >
          Get Started
        </button>

        <p 
          className="login-link"
          onClick={() => navigate('/login')}
        >
          Already have an account? Log In
        </p>
      </div>
    </section>
  );
}

export default WelcomePage;